import { MODULE_ID } from './constants';
export const INITIALIZE = `${MODULE_ID}/INITIALIZE`;
export const INITIALIZE_SUCCESS = `${MODULE_ID}/INITIALIZE_SUCCESS`;
export const INITIALIZE_ERROR = `${MODULE_ID}/INITIALIZE_ERROR`;
export const FETCH_ACCOUNT = `${MODULE_ID}/FETCH_ACCOUNT`;
export const FETCH_ACCOUNT_SUCCESS = `${MODULE_ID}/FETCH_ACCOUNT_SUCCESS`;
export const FETCH_ACCOUNT_ERROR = `${MODULE_ID}/FETCH_ACCOUNT_ERROR`;
export const FETCH_CLIENT = `${MODULE_ID}/FETCH_CLIENT`;
export const FETCH_CLIENT_SUCCESS = `${MODULE_ID}/FETCH_CLIENT_SUCCESS`;
export const FETCH_CLIENT_ERROR = `${MODULE_ID}/FETCH_CLIENT_ERROR`;
export const ACCEPT_CONSENTS = `${MODULE_ID}/ACCEPT_CONSENTS`;
export const ACCEPT_CONSENTS_SUCCESS = `${MODULE_ID}/ACCEPT_CONSENTS_SUCCESS`;
export const ACCEPT_CONSENTS_ERROR = `${MODULE_ID}/ACCEPT_CONSENTS_ERROR`;
export const REJECT_CONSENTS = `${MODULE_ID}/REJECT_CONSENTS`;
export const REJECT_CONSENTS_SUCCESS = `${MODULE_ID}/REJECT_CONSENTS_SUCCESS`;
export const REJECT_CONSENTS_ERROR = `${MODULE_ID}/REJECT_CONSENTS_ERROR`;
export const SET_CLIENT_ID = `${MODULE_ID}/SET_CLIENT_ID`;
